<div class="fullscreen-loader" id="loader"><UiBaseLoader></UiBaseLoader></div>